export default __webpack_public_path__ + "static/media/arrow_forward_blue-tata-neu.bc7ebb55.png";